import { graphql } from "gql.tada";

export const MediaGallerySectionById = graphql(
  `
    query MediaGallerySectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      mediaGallerySection(id: $id, preview: $preview, locale: $locale) {
        ...MediaGalleryFragment
      }
    }

    fragment MediaGalleryFragment on MediaGallerySection {
      mediaItemsCollection(limit: 30) {
        items {
          title
          itemMedia {
            url
            contentType
          }
        }
      }
    }
  `
);
